import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient } from '@angular/common/http';
import { routing } from './app/app.routing';
import { AppsModule } from "./app/app.module";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

platformBrowserDynamic().bootstrapModule(AppsModule)
  .then(success => console.log(`Bootstrap success`))
  .catch(err => console.error(err));
